export const isAuthenticated = (state) => !!state.auth.auth.access;

export const getCustomerNumber = (state) => state.auth.auth.customerNumber;

export const getUsername = (state) => state.auth.auth.username;
